import { theme as defaultTheme } from "@mindlercare/ui-web";
import { createTheme } from "@mui/material/styles";

export const MUItheme = createTheme({
  typography: {
    fontFamily: defaultTheme.FONT.FAMILY.BODY,
  },
  components: {
    MuiTableCell: {
      defaultProps: {
        padding: "checkbox",
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      variants: [
        {
          props: { color: "primary" },
          style: {
            color: defaultTheme.COLORS.GRAY_BLACK,
          },
        },
      ],
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            borderBottom: "1px solid #e3f0ed",
          },
          "&:after": {
            borderBottom: "1px solid #133028",
          },
          "&:hover:not($disabled):before": {
            borderBottom: "1px solid #e3f0ed",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          cursor: "pointer",
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          color: "#309973",
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          "&$checked + &": {
            backgroundColor: defaultTheme.COLORS.GRAY_BLACK,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: defaultTheme.COLORS.GRAY,
          fontFamily: defaultTheme.FONT.FAMILY.BODY,
          fontSize: defaultTheme.FONT.SIZE.STANDARD,
          height: "30px",
          minHeight: "18px",
        },
        indicator: {
          backgroundColor: defaultTheme.COLORS.PRIMARY_DARK,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "4px 10px",
          minHeight: "18px",
          fontSize: defaultTheme.FONT.SIZE.STANDARD,
        },
        textColorPrimary: {
          opacity: 1,
          color: defaultTheme.COLORS.GRAY,
          "&.Mui-selected": {
            color: defaultTheme.COLORS.BLACK,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paperWidthSm: {
          maxWidth: "100%",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 0,
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: defaultTheme.COLORS.GRAY_DARK,
          fontFamily: defaultTheme.FONT.FAMILY.BODY,
          fontSize: "0.75rem",
          fontWeight: 400,
          lineHeight: "17px",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.MuiMultiSectionDigitalClock-root:nth-of-type(3)": {
            overflow: "visible",
          },
        },
      },
    },
  },
});
